<router-outlet></router-outlet>
<ng-http-loader [filteredUrlPatterns]="['user/role/list', 'item/warehouse-tagging-location/list', 'user/dashboard', 'item/dashboard-item']"></ng-http-loader>